
export const triggerDownload = (fileUrl: string, fileName: string) => {
 const link = document.createElement('a');
 link.href = fileUrl;
 link.download = fileName;
 document.body.appendChild(link); // Append to the DOM
 link.click(); // Trigger the click
 document.body.removeChild(link); // Clean up
};
